import script from "./DisclaimerPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisclaimerPop.vue?vue&type=script&lang=ts&setup=true"

import "./DisclaimerPop.vue?vue&type=style&index=0&id=81b12116&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17+webpack@5.100.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81b12116"]])

export default __exports__